import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ToastProvider } from '@ankor-io/ui-components'
import '@ankor-io/ui-components/src/styles.css'
import './index.css'

import { QueryProvider } from '@/api'
import { ConfigProvider } from '@/providers/ConfigProvider'
import { GlobalLoadingProvider } from '@/providers/GlobalLoadingProvider'
import { KindeProvider } from '@/providers/KindeProvider'
import { UserContextProvider } from '@/providers/UserContextProvider'
import { DeferredRouter } from '@/routes/DeferredRouter'
import { getPathInfo } from '@/utils/route'

import { Router } from './routes/Router'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalLoadingProvider>
      <QueryProvider>
        <ConfigProvider>
          <KindeProvider>
            <UserContextProvider>
              <DeferredRouter
                router={<Router />}
                getPathInfo={getPathInfo}
              />
              <ToastProvider />
            </UserContextProvider>
          </KindeProvider>
        </ConfigProvider>
      </QueryProvider>
    </GlobalLoadingProvider>
  </StrictMode>,
)
